(function () {
  'use strict';
  var VALIDATE_URL = 'https://mantemi-order-webhook.spyrosfykas.workers.dev/validate-afm';

  if (customElements.get('invoice-fields')) return;

  // Write (or clear) invoice note_attributes on the Shopify cart.
  // CF Worker reads these from order.note_attributes after checkout.
  function updateCartAttributes(attrs) {
    return getCart()
      .then(function (cart) {
        var merged = Object.assign({}, (cart && cart.attributes) || {}, attrs);
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: merged })
        });
      })
      .catch(function () {
        // Non-fatal: cart attribute write failed (e.g. guest session timeout).
        // The CF Worker will see missing/non-invoice invoice_type and stamp "Αποδειξη".
        console.warn('[invoice-fields] cart/update.js failed');
      });
  }

  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }

  var INVOICE_ATTR_KEYS = [
    'invoice_type', 'invoice_afm', 'invoice_eponymia',
    'invoice_doy', 'invoice_address', 'invoice_drasthriothta',
    'invoice_cart_token'
  ];

  function receiptCartAttributes() {
    var attrs = {};
    INVOICE_ATTR_KEYS.forEach(function (k) { attrs[k] = ''; });
    attrs.invoice_type = 'receipt';
    return attrs;
  }

  function clearCartAttributes() {
    return updateCartAttributes(receiptCartAttributes());
  }

  function hasInvoiceAttributes(attrs) {
    return INVOICE_ATTR_KEYS.some(function (k) {
      return attrs && attrs[k] != null && String(attrs[k]).trim() !== '';
    });
  }

  function hasInvoiceDetailAttributes(attrs) {
    return INVOICE_ATTR_KEYS.some(function (k) {
      return k !== 'invoice_type' &&
        attrs &&
        attrs[k] != null &&
        String(attrs[k]).trim() !== '';
    });
  }

  customElements.define('invoice-fields', class extends HTMLElement {
    connectedCallback() {
      // Defer to next microtask so querySelector finds children regardless of
      // whether morph inserts the element before or after populating its children.
      Promise.resolve().then(() => this._init());
    }

    _init() {
      var self = this;
      if (!self.isConnected) return;
      if (self._initDone) return;
      self._initDone = true;

      var receipt  = self.querySelector('#invoice-type-receipt');
      var invoice  = self.querySelector('#invoice-type-invoice');
      var wrapper  = self.querySelector('#invoice-afm-wrapper');
      var afmInput = self.querySelector('#invoice-afm');
      var okBtn    = self.querySelector('#invoice-afm-ok');
      var result   = self.querySelector('#invoice-afm-result');
      var invoiceVerified = false;

      if (!receipt || !invoice || !wrapper) return;

      function getCheckoutBtn() {
        return (self.parentElement && self.parentElement.querySelector('#checkout')) || document.getElementById('checkout');
      }

      function syncCheckoutBtn() {
        var checkoutBtn = getCheckoutBtn();
        if (!checkoutBtn) return;
        var shouldDisable = invoice.checked && !invoiceVerified;
        if (shouldDisable) {
          checkoutBtn.disabled = true;
          checkoutBtn.setAttribute('aria-disabled', 'true');
          checkoutBtn.dataset.invoiceDisabled = 'true';
        } else if (checkoutBtn.dataset.invoiceDisabled === 'true') {
          checkoutBtn.disabled = false;
          checkoutBtn.removeAttribute('aria-disabled');
          delete checkoutBtn.dataset.invoiceDisabled;
        }
      }

      function showInvoiceFields() {
        wrapper.style.display = '';
      }

      function showReceiptFields(syncCart) {
        invoiceVerified = false;
        wrapper.style.display = 'none';
        clearResult();
        afmInput.value = '';
        syncOkBtn();
        syncCheckoutBtn();
        if (syncCart) clearCartAttributes();
      }

      function syncFromCart() {
        getCart().then(function (cart) {
          if (!self.isConnected) return;
          var attrs = (cart && cart.attributes) || {};
          var cartToken = cart && cart.token ? String(cart.token) : '';
          var attrToken = attrs.invoice_cart_token ? String(attrs.invoice_cart_token) : '';
          var afm = (attrs.invoice_afm || '').trim();
          var isCurrentInvoice =
            attrs.invoice_type === 'invoice' &&
            /^\d{9}$/.test(afm) &&
            attrToken &&
            cartToken &&
            attrToken === cartToken;

          if (isCurrentInvoice) {
            invoiceVerified = true;
            invoice.checked = true;
            receipt.checked = false;
            afmInput.value = afm;
            showInvoiceFields();
            syncOkBtn();
            if (attrs.invoice_eponymia) {
              var label = attrs.invoice_eponymia + (attrs.invoice_doy ? ' \u2014 ' + attrs.invoice_doy : '');
              setResult('ok', label);
            }
            syncCheckoutBtn();
            return;
          }

          invoiceVerified = false;
          receipt.checked = true;
          invoice.checked = false;
          showReceiptFields(false);
          if ((hasInvoiceAttributes(attrs) && attrs.invoice_type !== 'receipt') || hasInvoiceDetailAttributes(attrs)) {
            clearCartAttributes();
          }
        });
      }

      function toggleWrapper() {
        invoiceVerified = false;
        if (invoice.checked) {
          showInvoiceFields();
          syncCheckoutBtn();
        } else {
          showReceiptFields(true);
        }
      }
      receipt.addEventListener('change', toggleWrapper);
      receipt.addEventListener('click', function () {
        if (receipt.checked) showReceiptFields(true);
      });
      invoice.addEventListener('change', toggleWrapper);
      invoice.addEventListener('click', function () {
        if (!invoice.checked) return;
        showInvoiceFields();
        syncCheckoutBtn();
      });

      self._invoicePageShowHandler = function () {
        if (!self.isConnected) return;
        syncCheckoutBtn();
      };
      window.addEventListener('pageshow', self._invoicePageShowHandler);

      function syncOkBtn() {
        okBtn.disabled = !/^\d{9}$/.test(afmInput.value.trim());
      }
      syncOkBtn();

      afmInput.addEventListener('input', function () {
        invoiceVerified = false;
        clearResult();
        syncOkBtn();
        syncCheckoutBtn();
      });

      okBtn.addEventListener('click', function () {
        var afm = afmInput.value.trim();
        if (!/^\d{9}$/.test(afm)) {
          setResult('error', 'Ο ΑΦΜ πρέπει να έχει ακριβώς 9 ψηφία.');
          return;
        }
        setLoading(true);
        fetch(VALIDATE_URL + '?afm=' + encodeURIComponent(afm))
          .then(function (r) {
            return r.json().then(function (d) { return { ok: r.ok, data: d }; });
          })
          .then(function (res) {
            setLoading(false);
            var data = res.data;
            if (!res.ok || data.error) {
              invoiceVerified = false;
              syncCheckoutBtn();
              setResult('error', data.error || 'Σφάλμα κατά την επαλήθευση ΑΦΜ.');
              clearCartAttributes();
            } else if (!data.company) {
              invoiceVerified = false;
              syncCheckoutBtn();
              setResult('error', 'Δεν βρέθηκε επωνυμία για τον ΑΦΜ αυτό.');
              clearCartAttributes();
            } else {
              var label = data.company + (data.doy ? ' \u2014 ' + data.doy : '');
              setResult('ok', label);
              // Write all invoice data to cart note_attributes.
              // CF Worker (orders/create webhook) reads these and writes ORDER metafields.
              getCart().then(function (cart) {
                updateCartAttributes({
                  invoice_type:          'invoice',
                  invoice_afm:           afm,
                  invoice_eponymia:      data.company,
                  invoice_doy:           data.doy      || '',
                  invoice_address:       data.address  || '',
                  invoice_drasthriothta: data.kad       || '',
                  invoice_cart_token:    cart && cart.token ? String(cart.token) : ''
                }).then(function (response) {
                  invoiceVerified = !!(response && response.ok);
                  syncCheckoutBtn();
                });
              });
            }
          })
          .catch(function () {
            setLoading(false);
            invoiceVerified = false;
            syncCheckoutBtn();
            setResult('error', 'Σφάλμα σύνδεσης. Ελέγξτε τη σύνδεσή σας και δοκιμάστε ξανά.');
          });
      });

      afmInput.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); okBtn.click(); }
      });

      function setLoading(on) {
        okBtn.disabled = on || !/^\d{9}$/.test(afmInput.value.trim());
        okBtn.textContent = on ? '\u2026' : 'OK';
        if (on) clearResult();
      }

      function clearResult() {
        result.style.display = 'none';
        result.className = 'invoice-fields__result';
        result.innerHTML = '';
      }

      function setResult(type, text) {
        if (!type || !text) { clearResult(); return; }
        result.style.display = '';
        result.className = 'invoice-fields__result invoice-fields__result--' + type;
        var icon = type === 'ok'
          ? '<span class="invoice-fields__result-icon" aria-hidden="true">\u2713</span>'
          : '<span class="invoice-fields__result-icon" aria-hidden="true">\u2715</span>';
        result.innerHTML = icon + '<span>' + text + '</span>';
      }

      syncCheckoutBtn();
      syncFromCart();
    }

    disconnectedCallback() {
      if (this._invoicePageShowHandler) {
        window.removeEventListener('pageshow', this._invoicePageShowHandler);
        this._invoicePageShowHandler = null;
      }
      // Reset so _init() re-runs if morph re-inserts this element (e.g. after
      // add-to-cart from empty cart triggers a full cart-summary morph).
      this._initDone = false;
    }
  });
})();
